import { Loader } from '@progress/kendo-react-indicators';

export function Spinner({ size = 'medium' }: { size?: 'small' | 'medium' | 'large' }) {
  return <Loader type="converging-spinner" size={size} />;
}
